export const iconFontAwesomeSocialLocationDot = (
	<i className="fa-solid fa-location-dot"></i>
);
